import { render, staticRenderFns } from "./UploadMediaModal.vue?vue&type=template&id=dfdf5518&"
import script from "./UploadMediaModal.vue?vue&type=script&lang=js&"
export * from "./UploadMediaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports